import type { Breakpoint } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  isMobile,
  isTablet,
  isIOS,
  isIOS13,
  isIPad13,
  isIPhone13,
  isIPod13,
  isWinPhone,
  isMobileSafari,
} from 'react-device-detect';

export function useIsMobile(breakpoint: Breakpoint = 'sm') {
  const theme = useTheme();
  const isMqMatch = useMediaQuery(theme.breakpoints.down(breakpoint));

  const match =
    isMqMatch ||
    isMobile ||
    isTablet ||
    isIOS ||
    isIOS13 ||
    isIPad13 ||
    isIPhone13 ||
    isIPod13 ||
    isWinPhone ||
    isMobileSafari;
  return match;
}
